<template>
    <div class="nav-mobile" v-if="!hideNavbar()">
        <i class="material-icons btn-show-menu" @click.stop="toggleMenu()">menu</i>
        <div class="icons" v-if="!route.query.t === 'OD'">
            <span @click.stop="openHelpMenu()" >
                <i class="material-icons" >help</i>
                 {{$t('nav.HELP')}}
            </span>
            <span>
                <i class="material-icons">notifications</i>
                {{$t('nav.NOTIFICATIONS')}}
            </span>
        </div>
    </div>
</template>

<script>
import { useRoute } from 'vue-router';
//import { useStore } from 'vuex';
export default {
    setup(_, {emit}) {
        const route = useRoute();
        const locationsWhenHideNavbar = ['/preinscription/', '/contentshare']
        //const store = useStore();
        function toggleMenu() {
            emit('toggleMenuMobile');
        }
        function openHelpMenu(){
            emit('openHelpMenu');
        }

        const hideNavbar = () => locationsWhenHideNavbar.filter(location => route.path.toLowerCase().includes(location))?.length

        return{
            toggleMenu,
            openHelpMenu,
            route,
            hideNavbar
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";
.nav-mobile{
    height: 7vh;
    position: sticky;
    top: 0;
    padding: 0 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    color: $black;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    z-index: 2000;
    .btn-show-menu{
        font-size: 36px;
    }
    .icons{
        height: 100%;
        display: flex;
        align-items: center;
        gap: 24px;
        span{
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 600;
            gap: 6px;
            @media screen and (max-width: 345px){
                font-size: 10px;
            }
        }
        .material-icons{
            font-size: 28px;
            @media screen and (max-width: 345px){
                font-size: 20px;
            }
        }
    }
}
</style>